module.exports = __webpack_public_path__ + "static-portal/img/48-1.c527e02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/48-1.jpg
// module id = dM/s
// module chunks = 4